import React, { useState, useMemo } from 'react';
import { SearchField } from '@sas/nova-commons/components/SearchField';
export function SearchableList(props) {
    const [searchValue, setSearchValue] = useState('');
    const { searchResults, searchResultsIndices } = useMemo(() => {
        const searchResults = [];
        const searchResultsIndices = [];
        const searchPattern = searchValue.toLocaleLowerCase();
        for (const [index, value] of props.items.entries()) {
            if (value.text.toLocaleLowerCase().includes(searchPattern)) {
                searchResults.push(value);
                searchResultsIndices.push(index);
            }
        }
        return { searchResults, searchResultsIndices };
    }, [props.items, searchValue]);
    const selectedIndices = useMemo(() => {
        if (props.type === 'single') {
            return searchResultsIndices.indexOf(props.selection);
        }
        else {
            const indices = [];
            for (const [index, val] of searchResultsIndices.entries()) {
                if (props.selection.has(val))
                    indices.push(index);
            }
            return new Set(indices);
        }
    }, [searchResultsIndices, props.selection, props.type]);
    return (React.createElement("div", { style: { overflowY: 'hidden', height: '100%', display: 'flex', flexDirection: 'column' }, tabIndex: -1 },
        React.createElement("div", { style: { padding: '0.1875rem 0 0.1875rem 0.5rem', display: 'flex' } },
            React.createElement(SearchField, { filterMode: true, value: searchValue, onChange: (e) => {
                    setSearchValue(e.value);
                } })),
        props.type === 'single'
            ? props.renderList(searchResults, selectedIndices, (index) => props.onSelected(searchResultsIndices[index]))
            : props.renderList(searchResults, selectedIndices, (index) => {
                const visibleSearchResults = new Set([...index].map((i) => searchResultsIndices[i]));
                const allSearchResults = new Set(searchResultsIndices);
                // Preserves items hidden by search that are still selected
                for (const item of props.selection) {
                    if (!allSearchResults.has(item))
                        visibleSearchResults.add(item);
                }
                props.onSelected(visibleSearchResults);
            })));
}
